<template>
  <!-- Success Modal -->
  <div
    id="successModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="successModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5
            id="successModalLabel"
            class="modal-title"
          >
            {{ $t('label.modal.SUCCESS_MODAL_LABEL') }}
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>
        <div class="modal-body">
          <div class="alert alert-success">
            <p id="successModalMsg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap'
export default {
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  created () {
  },

  methods: {
    showSuccess (msg) {
      let successModal = new Modal(document.getElementById('successModal'))
      successModal.show()
      document.getElementById('successModalMsg').innerHTML = msg
    }
  }
}
</script>

<style scoped lang="scss">

</style>
